import React, { useState } from "react";
import {
  BalanceSheetWidget,
  BalanceSheetWidgetProps,
  WidgetError,
  WidgetMessage,
  FiscalYear,
  WidgetHeightMessage,
  ThemeType,
  WidgetNameSource,
} from "@labci/bell-fg-widgets";
import { Spin } from "antd";
import CircularProgress from "../Components/CircularProgress/CircularProgress";

const BalanceSheet: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const token = queryParams.get("token") || "";
  const symbol = queryParams.get("symbol") || "";
  const select = queryParams.get("select") || FiscalYear.Latest;
  const theme = queryParams.get("theme") || ThemeType.Direct;

  const handleNoData = (message: WidgetMessage) => {
    console.log("handleNoData", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(error),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };

  const handleLoadingChange = (loading: boolean) => {
    setIsLoading(loading);

    const loadingMessage = {
      type: "loading",
      value: loading,
      source: WidgetNameSource.BalanceSheet,
    };
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(loadingMessage),
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(loadingMessage), "*");
  };

  const handleHeightChange = (messages: WidgetHeightMessage) => {
    console.log("handleHeightChange", messages);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(messages));
      return;
    }
    window.parent.postMessage(JSON.stringify(messages), "*");
  };

  const props: BalanceSheetWidgetProps = {
    symbol: symbol,
    token: token,
    select: select as FiscalYear,
    theme: theme as ThemeType,
    onError: handleError,
    onNoData: handleNoData,
    onLoadingChange: handleLoadingChange,
    onHeightChange: handleHeightChange,
  };

  return (
    <Spin
      wrapperClassName="widget-spin"
      spinning={isLoading}
      indicator={<CircularProgress theme={theme as ThemeType} />}
    >
      <BalanceSheetWidget {...props} />
    </Spin>
  );
};

export default BalanceSheet;
